const FecalColor = [
  "Dark Brown",
  "Brown",
  "Light Brown",
  "Dark Yellow",
  "Yellow",
  "Reddish",
  "Greenish",
  "Gray",
  "White",
  "Black",
];

export default FecalColor;
